import { render, staticRenderFns } from "./UserViewInfoCardPartOne.vue?vue&type=template&id=6b754ff0&scoped=true"
import script from "./UserViewInfoCardPartOne.vue?vue&type=script&lang=js"
export * from "./UserViewInfoCardPartOne.vue?vue&type=script&lang=js"
import style0 from "./UserViewInfoCardPartOne.vue?vue&type=style&index=0&id=6b754ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b754ff0",
  null
  
)

export default component.exports